import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { SpaceService } from './../../../services/space.service';
import { MemberService } from './../../../rest/api/member.service';
import { AuthService } from './../../../services/auth.service';

import _ from 'lodash';
@Component({
  selector: 'app-floorplan',
  templateUrl: './floorplan.component.html',
  styleUrls: ['./floorplan.component.scss']
})
export class FloorplanComponent implements OnInit {
  spaceData: any;
  floorPlanData: any;
  accessToken: any;
  loading = true;
  mediaData: any;
  floorPlanEditClicked = false;

  editFloorplanImageClicked = false;
  deleteFloorplanImageClicked = false;
  @Output() deleteFloorplanImageEmit = new EventEmitter();


  constructor(
    public spaceService: SpaceService,
    private authService: AuthService,
    public memberService: MemberService,
    public router: Router
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }
  ngOnInit() {
    this.spaceService.spaceDataSubscription.subscribe(response => {
      if (Object.keys(response).length === 0 && response.constructor === Object) {
        this.router.navigate(['/member']);
      }
      if (response) {
        this.spaceData = response;
        this.getFloorPlan();
        this.getMediaDetails();
      }
    });
  }

  getFloorPlan() {
    this.memberService.getFloorPlan({
      Authorization: this.accessToken,
      id: this.spaceData.uuid
    }).subscribe((response: any) => {
      this.floorPlanData = response && response.data ? response.data : null;
      this.loading = false;
    }, err => {
      this.floorPlanData = null;
      this.loading = false;
    });
  }

  uploadImagesEmit() {
    this.loading = true;
    this.getFloorPlan();
  }

  getMediaDetails() {
    this.memberService.getMemberSpaceMediaDetails({
      Authorization: this.accessToken,
      id: this.spaceData.uuid
    }).subscribe((response: any) => {
      this.mediaData = response && response.media ? response.media : [];
      this.loading = false;
    }, err => {
      this.router.navigate(['/member']);
    });
  }

  editFlootplan() {
    this.floorPlanEditClicked = true;
  }

  closeModalEmit() {
    setTimeout(() => {
      this.floorPlanEditClicked = false;
    }, 500);
  }

  updateFloorplanimage() {
    this.editFloorplanImageClicked = true;
  }

  updateFloorplanImageEmit(response) {
    if ($('#updatefloorplanImage')) {
      $('#updatefloorplanImage').modal('hide');
    }
    setTimeout(() => {
      this.editFloorplanImageClicked = false;
    }, 500);
    this.loading = true;
    this.floorPlanData = undefined;
    this.getFloorPlan();
  }

  deleteFloorplan() {
    this.deleteFloorplanImageClicked = true;
  }

  deleteFloorPlanEmit() {
    if ($('#deleteFloorplan')) {
      $('#deleteFloorplan').modal('hide');
    }
    setTimeout(() => {
      this.deleteFloorplanImageClicked = false;
    }, 500);
    this.loading = true;
    this.floorPlanData = null;
    this.getFloorPlan();
  }
}

